import { useIsFromEventsDirectory } from "@circle-react/hooks/useIsFromEventsDirectory";
import { useLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useRouteHelpers } from "@circle-react/routes/Main/useRouteHelpers";

export const useSidebarDisabledV3 = () => {
  const {
    isSpaceRoute,
    isSpaceGroupRoute,
    isFeedRoute,
    isGettingStartedRoute,
  } = useRouteHelpers();
  const isLgScreen = useLgScreenMediaQuery();
  const isFromEventsDirectory = useIsFromEventsDirectory();

  return (
    (!isSpaceRoute || isFromEventsDirectory) &&
    !isSpaceGroupRoute &&
    !isFeedRoute &&
    !isGettingStartedRoute &&
    isLgScreen
  );
};
